// extracted by mini-css-extract-plugin
module.exports = {"ocean-pro-home-solar-battery":"OceanSmartElectricalPanel40_ocean-pro-home-solar-battery__bKi6s","FAQ":"OceanSmartElectricalPanel40_FAQ__ef_o0"};